import React, { ChangeEvent } from 'react';
import SmallInput from './input-small/input-small.styled';
import LargeInput from './input-large/input-large.styled';

export interface InputProps {
  type: string;
  size?: 'small';
  placeholder?: string;
  onChange?: (value: string) => void;
  className?: string;
  value?: string | number;
  name?: string;
  disabled?: boolean;
  isInvalid?: boolean;
  autoComplete?: string;
  id?: string;
}

const Input = ({
  placeholder,
  size,
  className = '',
  type,
  onChange,
  value = '',
  name,
  disabled = false,
  isInvalid,
  autoComplete,
  id,
}: InputProps): JSX.Element | null => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!onChange) {
      return null;
    }
    return onChange(e.target.value);
  };
  switch (size) {
    case 'small':
      return (
        <SmallInput
          type={type}
          placeholder={placeholder}
          onChange={handleChange}
          className={className}
          value={value}
          name={name}
          disabled={disabled}
          $isInvalid={isInvalid}
          autoComplete={autoComplete}
          id={id}
        />
      );
    default:
      return (
        <LargeInput
          type={type}
          placeholder={placeholder}
          onChange={handleChange}
          className={className}
          value={value}
          name={name}
          disabled={disabled}
          $isInvalid={isInvalid}
          autoComplete={autoComplete}
          id={id}
        />
      );
  }
};

export default Input;
